module.exports = __webpack_public_path__ + "media/images/countrysquared/kp-1d35793fc5ff4fc24fd3a925785c376f.svg";